$(document).on("ready page:load", function() {
  $(".notnow-btn").click(function () {
    $(".feature-message").hide();
  });
});

window.feature_visited = function (feature_ids) {
  if(feature_ids.length > 0) {
    $.ajax({
      type: 'PUT',
      url: "/feature_messages/"+feature_ids[0],
      data: { ids: feature_ids }
    });
  }
}
